import { render, staticRenderFns } from "./prescribingInfo.vue?vue&type=template&id=1a702628&scoped=true"
import script from "./prescribingInfo.vue?vue&type=script&lang=js"
export * from "./prescribingInfo.vue?vue&type=script&lang=js"
import style0 from "./prescribingInfo.vue?vue&type=style&index=0&id=1a702628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a702628",
  null
  
)

export default component.exports